import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {TooltipOverflowCondition} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipOverflowCondition';
import {Link} from '../../../../models/api/cardModel';
import {LinkifyFormatter} from '../../../common/formatters/markdown/linkifyFormatter';
import {LinkTrap} from '../../../common/linkTrap/linkTrap';
import {MultilineTooltipOverflowCondition} from '../../../common/tooltips/multilineTooltipOverflowCondition';
import {ContactCardSectionItem} from './contactCardSectionItem';

/*
 * Props.
 */

interface ContactCardLinkItemProps {
  link: Link;
  title?: ReactNode;
  shouldAllowMultiLineWrapping?: boolean;
}

/*
 * Style.
 */

const StyledLinkTrap = styled(LinkTrap)`
  & > p {
    margin: 0;

    & > a {
      color: ${(p) => p.theme.interactiveText};
      &:hover {
        color: ${(p) => p.theme.interactiveTextHover};
      }
    }
  }
`;

/*
 * Component.
 */

export const ContactCardLinkItem: FC<ContactCardLinkItemProps> = (props) => {
  const {link, title, shouldAllowMultiLineWrapping} = props;
  return (
    <ContactCardSectionItem title={title} copyInfo={link.url}>
      <TooltipCoordinator placement="top" render={() => link.url}>
        {renderContentWithOverflow(
          <StyledLinkTrap>
            <LinkifyFormatter text={link.url} />
          </StyledLinkTrap>,
          shouldAllowMultiLineWrapping,
        )}
      </TooltipCoordinator>
    </ContactCardSectionItem>
  );
};

/*
 * Helpers.
 */

function renderContentWithOverflow(content: ReactNode, shouldAllowMultiLineWrapping?: boolean) {
  if (shouldAllowMultiLineWrapping) {
    return <MultilineTooltipOverflowCondition lines={3}>{content}</MultilineTooltipOverflowCondition>;
  }
  return <TooltipOverflowCondition>{content}</TooltipOverflowCondition>;
}
